import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Additive = {
  __typename?: 'Additive';
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type Allergen = {
  __typename?: 'Allergen';
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type BooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAdditiveInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAllergenInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFoodCategoryInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFoodMenueInput = {
  category?: InputMaybe<SelectOptionInput>;
  displayday?: InputMaybe<Scalars['Int']['input']>;
  foodtype?: InputMaybe<SelectOptionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productinformation?: InputMaybe<Array<InputMaybe<SelectOptionInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserinformationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyStartDate?: InputMaybe<Scalars['Int']['input']>;
  notifyUserOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWebsiteEventsInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageurl?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWebsiteLegalInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprint?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebsiteNewsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebsitePartnerInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebsiteSettingsInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  breakfasttimefrom?: InputMaybe<Scalars['String']['input']>;
  breakfasttimeto?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<KeywordInput>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  opendayfrom?: InputMaybe<SelectOptionInput>;
  opendayto?: InputMaybe<SelectOptionInput>;
  opentimefrom?: InputMaybe<Scalars['String']['input']>;
  opentimeto?: InputMaybe<Scalars['String']['input']>;
  postalcode?: InputMaybe<Scalars['String']['input']>;
  streetname?: InputMaybe<Scalars['String']['input']>;
  telephonenumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAdditiveInput = {
  id: Scalars['String']['input'];
};

export type DeleteAllergenInput = {
  id: Scalars['String']['input'];
};

export type DeleteFoodCategoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteFoodMenueInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserinformationInput = {
  id: Scalars['String']['input'];
};

export type DeleteWebsiteEventsInput = {
  id: Scalars['String']['input'];
};

export type DeleteWebsiteNewsInput = {
  id: Scalars['String']['input'];
};

export type DeleteWebsitePartnerInput = {
  id: Scalars['String']['input'];
};

export type FilterAdditiveInput = {
  created_at?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterAllergeneInput = {
  created_at?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterFoodCategoryInput = {
  created_at?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterFoodMenueInput = {
  created_at?: InputMaybe<IntFilterInput>;
  displayday?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
  week?: InputMaybe<IntFilterInput>;
};

export type FilterInput = {
  created_at?: InputMaybe<IntFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterUserinformationInput = {
  created_at?: InputMaybe<IntFilterInput>;
  from?: InputMaybe<IntFilterInput>;
  to?: InputMaybe<IntFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterWebsiteEventsInput = {
  created_at?: InputMaybe<IntFilterInput>;
  from?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  to?: InputMaybe<IntFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterWebsiteNewsInput = {
  created_at?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FilterWebsitePartnerInput = {
  created_at?: InputMaybe<IntFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  updated_at?: InputMaybe<IntFilterInput>;
};

export type FoodCategory = {
  __typename?: 'FoodCategory';
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type FoodMenue = {
  __typename?: 'FoodMenue';
  category?: Maybe<SelectOption>;
  created_at?: Maybe<Scalars['Int']['output']>;
  displayday?: Maybe<Scalars['Int']['output']>;
  foodtype?: Maybe<SelectOption>;
  id?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productinformation?: Maybe<Array<Maybe<SelectOption>>>;
  sortnumber?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

export type IntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type Keyword = {
  __typename?: 'Keyword';
  value?: Maybe<Scalars['String']['output']>;
};

export type KeywordInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAdditive?: Maybe<Additive>;
  createAllergen?: Maybe<Allergen>;
  createFoodCategory?: Maybe<FoodCategory>;
  createFoodMenue?: Maybe<FoodMenue>;
  createUserinformation?: Maybe<Userinformation>;
  createWebsiteEvents?: Maybe<WebsiteEvents>;
  createWebsiteLegal?: Maybe<WebsiteLegal>;
  createWebsiteNews?: Maybe<WebsiteNews>;
  createWebsitePartner?: Maybe<WebsitePartner>;
  createWebsiteSettings?: Maybe<WebsiteSettings>;
  createWeeklyFoodMenue?: Maybe<FoodMenue>;
  deleteAdditive?: Maybe<Additive>;
  deleteAllergen?: Maybe<Allergen>;
  deleteFoodCategory?: Maybe<FoodCategory>;
  deleteFoodMenue?: Maybe<FoodMenue>;
  deleteUserinformation?: Maybe<Userinformation>;
  deleteWebsiteEvents?: Maybe<WebsiteEvents>;
  deleteWebsiteNews?: Maybe<WebsiteNews>;
  deleteWebsitePartner?: Maybe<WebsitePartner>;
  updateAdditive?: Maybe<Additive>;
  updateAllergen?: Maybe<Allergen>;
  updateFoodCategory?: Maybe<FoodCategory>;
  updateFoodMenue?: Maybe<FoodMenue>;
  updateSortnumbers?: Maybe<Scalars['String']['output']>;
  updateUserinformation?: Maybe<Userinformation>;
  updateWebsiteEvents?: Maybe<WebsiteEvents>;
  updateWebsiteLegal?: Maybe<WebsiteLegal>;
  updateWebsiteNews?: Maybe<WebsiteNews>;
  updateWebsitePartner?: Maybe<WebsitePartner>;
  updateWebsiteSection?: Maybe<WebsiteSection>;
  updateWebsiteSettings?: Maybe<WebsiteSettings>;
};


export type MutationCreateAdditiveArgs = {
  input: CreateAdditiveInput;
};


export type MutationCreateAllergenArgs = {
  input: CreateAllergenInput;
};


export type MutationCreateFoodCategoryArgs = {
  input: CreateFoodCategoryInput;
};


export type MutationCreateFoodMenueArgs = {
  input: CreateFoodMenueInput;
};


export type MutationCreateUserinformationArgs = {
  input: CreateUserinformationInput;
};


export type MutationCreateWebsiteEventsArgs = {
  input: CreateWebsiteEventsInput;
};


export type MutationCreateWebsiteLegalArgs = {
  input: CreateWebsiteLegalInput;
};


export type MutationCreateWebsiteNewsArgs = {
  input: CreateWebsiteNewsInput;
};


export type MutationCreateWebsitePartnerArgs = {
  input: CreateWebsitePartnerInput;
};


export type MutationCreateWebsiteSettingsArgs = {
  input: CreateWebsiteSettingsInput;
};


export type MutationCreateWeeklyFoodMenueArgs = {
  input: CreateFoodMenueInput;
};


export type MutationDeleteAdditiveArgs = {
  input: DeleteAdditiveInput;
};


export type MutationDeleteAllergenArgs = {
  input: DeleteAllergenInput;
};


export type MutationDeleteFoodCategoryArgs = {
  input: DeleteFoodCategoryInput;
};


export type MutationDeleteFoodMenueArgs = {
  input: DeleteFoodMenueInput;
};


export type MutationDeleteUserinformationArgs = {
  input: DeleteUserinformationInput;
};


export type MutationDeleteWebsiteEventsArgs = {
  input: DeleteWebsiteEventsInput;
};


export type MutationDeleteWebsiteNewsArgs = {
  input: DeleteWebsiteNewsInput;
};


export type MutationDeleteWebsitePartnerArgs = {
  input: DeleteWebsitePartnerInput;
};


export type MutationUpdateAdditiveArgs = {
  input: UpdateAdditiveInput;
};


export type MutationUpdateAllergenArgs = {
  input: UpdateAllergenInput;
};


export type MutationUpdateFoodCategoryArgs = {
  input: UpdateFoodCategoryInput;
};


export type MutationUpdateFoodMenueArgs = {
  input: UpdateFoodMenueInput;
};


export type MutationUpdateSortnumbersArgs = {
  id1: Scalars['String']['input'];
  id2: Scalars['String']['input'];
  sortnumber1: Scalars['Int']['input'];
  sortnumber2: Scalars['Int']['input'];
};


export type MutationUpdateUserinformationArgs = {
  input: UpdateUserinformationInput;
};


export type MutationUpdateWebsiteEventsArgs = {
  input: UpdateWebsiteEventsInput;
};


export type MutationUpdateWebsiteLegalArgs = {
  input: UpdateWebsiteLegalInput;
};


export type MutationUpdateWebsiteNewsArgs = {
  input: UpdateWebsiteNewsInput;
};


export type MutationUpdateWebsitePartnerArgs = {
  input: UpdateWebsitePartnerInput;
};


export type MutationUpdateWebsiteSectionArgs = {
  input: UpdateWebsiteSectionInput;
};


export type MutationUpdateWebsiteSettingsArgs = {
  input: UpdateWebsiteSettingsInput;
};

export type PaginatedAdditives = {
  __typename?: 'PaginatedAdditives';
  items?: Maybe<Array<Maybe<Additive>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedAllergens = {
  __typename?: 'PaginatedAllergens';
  items?: Maybe<Array<Maybe<Allergen>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedFoodCategories = {
  __typename?: 'PaginatedFoodCategories';
  items?: Maybe<Array<Maybe<FoodCategory>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedFoodMenues = {
  __typename?: 'PaginatedFoodMenues';
  items?: Maybe<Array<Maybe<FoodMenue>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedUserinformations = {
  __typename?: 'PaginatedUserinformations';
  items?: Maybe<Array<Maybe<Userinformation>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedWebsiteEvents = {
  __typename?: 'PaginatedWebsiteEvents';
  items?: Maybe<Array<Maybe<WebsiteEvents>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedWebsiteLegal = {
  __typename?: 'PaginatedWebsiteLegal';
  items?: Maybe<Array<Maybe<WebsiteLegal>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedWebsiteNews = {
  __typename?: 'PaginatedWebsiteNews';
  items?: Maybe<Array<Maybe<WebsiteNews>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedWebsitePartners = {
  __typename?: 'PaginatedWebsitePartners';
  items?: Maybe<Array<Maybe<WebsitePartner>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedWebsiteSections = {
  __typename?: 'PaginatedWebsiteSections';
  items?: Maybe<Array<Maybe<WebsiteSection>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedWebsiteSettings = {
  __typename?: 'PaginatedWebsiteSettings';
  items?: Maybe<Array<Maybe<WebsiteSettings>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  listAdditives?: Maybe<PaginatedAdditives>;
  listAllergens?: Maybe<PaginatedAllergens>;
  listFoodCategories?: Maybe<PaginatedFoodCategories>;
  listFoodMenues?: Maybe<PaginatedFoodMenues>;
  listUserinformations?: Maybe<PaginatedUserinformations>;
  listWebsiteEvents?: Maybe<PaginatedWebsiteEvents>;
  listWebsiteLegal?: Maybe<PaginatedWebsiteLegal>;
  listWebsiteNews?: Maybe<PaginatedWebsiteNews>;
  listWebsitePartners?: Maybe<PaginatedWebsitePartners>;
  listWebsiteSections?: Maybe<PaginatedWebsiteSections>;
  listWebsiteSettings?: Maybe<PaginatedWebsiteSettings>;
  listWeeklyFoodMenues?: Maybe<PaginatedFoodMenues>;
};


export type QueryListAdditivesArgs = {
  filter?: InputMaybe<FilterAdditiveInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAllergensArgs = {
  filter?: InputMaybe<FilterAllergeneInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListFoodCategoriesArgs = {
  filter?: InputMaybe<FilterFoodCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListFoodMenuesArgs = {
  filter?: InputMaybe<FilterFoodMenueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserinformationsArgs = {
  filter?: InputMaybe<FilterUserinformationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWebsiteEventsArgs = {
  filter?: InputMaybe<FilterWebsiteEventsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWebsiteLegalArgs = {
  filter?: InputMaybe<FilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWebsiteNewsArgs = {
  filter?: InputMaybe<FilterWebsiteNewsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWebsitePartnersArgs = {
  filter?: InputMaybe<FilterWebsitePartnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWebsiteSectionsArgs = {
  filter?: InputMaybe<FilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWebsiteSettingsArgs = {
  filter?: InputMaybe<FilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWeeklyFoodMenuesArgs = {
  filter?: InputMaybe<FilterFoodMenueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SelectOptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdditiveInput = {
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAllergenInput = {
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFoodCategoryInput = {
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFoodMenueInput = {
  category?: InputMaybe<SelectOptionInput>;
  displayday?: InputMaybe<Scalars['Int']['input']>;
  foodtype?: InputMaybe<SelectOptionInput>;
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productinformation?: InputMaybe<Array<InputMaybe<SelectOptionInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserinformationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyStartDate?: InputMaybe<Scalars['Int']['input']>;
  notifyUserOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWebsiteEventsInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  imageurl?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWebsiteLegalInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imprint?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebsiteNewsInput = {
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebsitePartnerInput = {
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebsiteSectionInput = {
  id: Scalars['String']['input'];
  key?: InputMaybe<WebsiteSectionKeyEnum>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebsiteSettingsInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  breakfasttimefrom?: InputMaybe<Scalars['String']['input']>;
  breakfasttimeto?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  keywords?: InputMaybe<Array<InputMaybe<KeywordInput>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  opendayfrom?: InputMaybe<SelectOptionInput>;
  opendayto?: InputMaybe<SelectOptionInput>;
  opentimefrom?: InputMaybe<Scalars['String']['input']>;
  opentimeto?: InputMaybe<Scalars['String']['input']>;
  postalcode?: InputMaybe<Scalars['String']['input']>;
  streetname?: InputMaybe<Scalars['String']['input']>;
  telephonenumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Userinformation = {
  __typename?: 'Userinformation';
  created_at?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_closed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifyStartDate?: Maybe<Scalars['Int']['output']>;
  notifyUserOnWebsite?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type WebsiteEvents = {
  __typename?: 'WebsiteEvents';
  created_at?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageurl?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type WebsiteLegal = {
  __typename?: 'WebsiteLegal';
  created_at?: Maybe<Scalars['Int']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type WebsiteNews = {
  __typename?: 'WebsiteNews';
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type WebsitePartner = {
  __typename?: 'WebsitePartner';
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WebsiteSection = {
  __typename?: 'WebsiteSection';
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<WebsiteSectionKeyEnum>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export enum WebsiteSectionKeyEnum {
  WebsiteSectionAbout = 'website_section_about',
  WebsiteSectionEvents = 'website_section_events',
  WebsiteSectionGallery = 'website_section_gallery',
  WebsiteSectionMenue = 'website_section_menue',
  WebsiteSectionNews = 'website_section_news',
  WebsiteSectionWeeklymenue = 'website_section_weeklymenue'
}

export type WebsiteSettings = {
  __typename?: 'WebsiteSettings';
  author?: Maybe<Scalars['String']['output']>;
  breakfasttimefrom?: Maybe<Scalars['String']['output']>;
  breakfasttimeto?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Keyword>>>;
  location?: Maybe<Scalars['String']['output']>;
  opendayfrom?: Maybe<SelectOption>;
  opendayto?: Maybe<SelectOption>;
  opentimefrom?: Maybe<Scalars['String']['output']>;
  opentimeto?: Maybe<Scalars['String']['output']>;
  postalcode?: Maybe<Scalars['String']['output']>;
  streetname?: Maybe<Scalars['String']['output']>;
  telephonenumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
};

export type CreateUserinformationMutationVariables = Exact<{
  input: CreateUserinformationInput;
}>;


export type CreateUserinformationMutation = { createUserinformation?: { __typename?: 'Userinformation', id?: string | null, name?: string | null, from?: number | null, to?: number | null, description?: string | null, notifyUserOnWebsite?: boolean | null, is_closed?: boolean | null, notifyStartDate?: number | null, updated_at?: number | null } | null };

export type DeleteUserinformationMutationVariables = Exact<{
  input: DeleteUserinformationInput;
}>;


export type DeleteUserinformationMutation = { deleteUserinformation?: { __typename?: 'Userinformation', id?: string | null } | null };

export type GetUserinformationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserinformationsQuery = { listUserinformations?: { __typename?: 'PaginatedUserinformations', items?: Array<{ __typename?: 'Userinformation', id?: string | null, name?: string | null, from?: number | null, to?: number | null, description?: string | null, notifyUserOnWebsite?: boolean | null, is_closed?: boolean | null, notifyStartDate?: number | null, updated_at?: number | null } | null> | null } | null };

export type UpdateHolidayMutationVariables = Exact<{
  input: UpdateUserinformationInput;
}>;


export type UpdateHolidayMutation = { updateUserinformation?: { __typename?: 'Userinformation', id?: string | null, name?: string | null, from?: number | null, to?: number | null, description?: string | null, notifyUserOnWebsite?: boolean | null, is_closed?: boolean | null, notifyStartDate?: number | null, updated_at?: number | null } | null };

export type CreateWebsiteSettingsMutationVariables = Exact<{
  input: CreateWebsiteSettingsInput;
}>;


export type CreateWebsiteSettingsMutation = { createWebsiteSettings?: { __typename?: 'WebsiteSettings', title?: string | null, author?: string | null, description?: string | null, opentimefrom?: string | null, opentimeto?: string | null, breakfasttimefrom?: string | null, breakfasttimeto?: string | null, streetname?: string | null, postalcode?: string | null, location?: string | null, telephonenumber?: string | null, email?: string | null, keywords?: Array<{ __typename?: 'Keyword', value?: string | null } | null> | null, opendayfrom?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, opendayto?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null } | null };

export type GetWebsiteSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsiteSectionsQuery = { listWebsiteSections?: { __typename?: 'PaginatedWebsiteSections', items?: Array<{ __typename?: 'WebsiteSection', id?: string | null, key?: WebsiteSectionKeyEnum | null, title?: string | null, subtitle?: string | null } | null> | null } | null };

export type GetWebsiteSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsiteSettingsQuery = { listWebsiteSettings?: { __typename?: 'PaginatedWebsiteSettings', items?: Array<{ __typename?: 'WebsiteSettings', id?: string | null, title?: string | null, author?: string | null, description?: string | null, opentimefrom?: string | null, opentimeto?: string | null, breakfasttimefrom?: string | null, breakfasttimeto?: string | null, streetname?: string | null, postalcode?: string | null, location?: string | null, telephonenumber?: string | null, email?: string | null, keywords?: Array<{ __typename?: 'Keyword', value?: string | null } | null> | null, opendayfrom?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, opendayto?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null } | null> | null } | null };

export type UpdateSortnumbersMutationVariables = Exact<{
  id1: Scalars['String']['input'];
  sortnumber1: Scalars['Int']['input'];
  id2: Scalars['String']['input'];
  sortnumber2: Scalars['Int']['input'];
}>;


export type UpdateSortnumbersMutation = { updateSortnumbers?: string | null };

export type UpdateWebsiteSectionMutationVariables = Exact<{
  input: UpdateWebsiteSectionInput;
}>;


export type UpdateWebsiteSectionMutation = { updateWebsiteSection?: { __typename?: 'WebsiteSection', id?: string | null, title?: string | null, subtitle?: string | null } | null };

export type UpdateWebsiteSettingsMutationVariables = Exact<{
  input: UpdateWebsiteSettingsInput;
}>;


export type UpdateWebsiteSettingsMutation = { updateWebsiteSettings?: { __typename?: 'WebsiteSettings', id?: string | null, title?: string | null, author?: string | null, description?: string | null, opentimefrom?: string | null, opentimeto?: string | null, breakfasttimefrom?: string | null, breakfasttimeto?: string | null, streetname?: string | null, postalcode?: string | null, location?: string | null, telephonenumber?: string | null, email?: string | null, keywords?: Array<{ __typename?: 'Keyword', value?: string | null } | null> | null, opendayfrom?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, opendayto?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null } | null };

export type CreateWebsiteEventsMutationVariables = Exact<{
  input: CreateWebsiteEventsInput;
}>;


export type CreateWebsiteEventsMutation = { createWebsiteEvents?: { __typename?: 'WebsiteEvents', id?: string | null, title?: string | null, location?: string | null, from?: number | null, to?: number | null, imageurl?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type DeleteWebsiteEventsMutationVariables = Exact<{
  input: DeleteWebsiteEventsInput;
}>;


export type DeleteWebsiteEventsMutation = { deleteWebsiteEvents?: { __typename?: 'WebsiteEvents', id?: string | null, imageurl?: string | null } | null };

export type GetWebsiteEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsiteEventsQuery = { listWebsiteEvents?: { __typename?: 'PaginatedWebsiteEvents', items?: Array<{ __typename?: 'WebsiteEvents', id?: string | null, title?: string | null, location?: string | null, from?: number | null, to?: number | null, imageurl?: string | null, is_active?: boolean | null, updated_at?: number | null } | null> | null } | null };

export type UpdateWebsiteEventsMutationVariables = Exact<{
  input: UpdateWebsiteEventsInput;
}>;


export type UpdateWebsiteEventsMutation = { updateWebsiteEvents?: { __typename?: 'WebsiteEvents', id?: string | null, title?: string | null, location?: string | null, from?: number | null, to?: number | null, imageurl?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type CreateAdditiveMutationVariables = Exact<{
  input: CreateAdditiveInput;
}>;


export type CreateAdditiveMutation = { createAdditive?: { __typename?: 'Additive', id?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type DeleteAdditiveMutationVariables = Exact<{
  input: DeleteAdditiveInput;
}>;


export type DeleteAdditiveMutation = { deleteAdditive?: { __typename?: 'Additive', id?: string | null } | null };

export type GetAdditivesQueryVariables = Exact<{
  Limit?: InputMaybe<Scalars['Int']['input']>;
  NextToken?: InputMaybe<Scalars['String']['input']>;
  Filter?: InputMaybe<FilterAdditiveInput>;
}>;


export type GetAdditivesQuery = { listAdditives?: { __typename?: 'PaginatedAdditives', items?: Array<{ __typename?: 'Additive', id?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null> | null } | null };

export type UpdateAdditiveMutationVariables = Exact<{
  input: UpdateAdditiveInput;
}>;


export type UpdateAdditiveMutation = { updateAdditive?: { __typename?: 'Additive', id?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type CreateAllergenMutationVariables = Exact<{
  input: CreateAllergenInput;
}>;


export type CreateAllergenMutation = { createAllergen?: { __typename?: 'Allergen', id?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type DeleteAllergenMutationVariables = Exact<{
  input: DeleteAllergenInput;
}>;


export type DeleteAllergenMutation = { deleteAllergen?: { __typename?: 'Allergen', id?: string | null } | null };

export type GetAllergensQueryVariables = Exact<{
  Limit?: InputMaybe<Scalars['Int']['input']>;
  NextToken?: InputMaybe<Scalars['String']['input']>;
  Filter?: InputMaybe<FilterAllergeneInput>;
}>;


export type GetAllergensQuery = { listAllergens?: { __typename?: 'PaginatedAllergens', items?: Array<{ __typename?: 'Allergen', id?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null> | null } | null };

export type UpdateAllergenMutationVariables = Exact<{
  input: UpdateAllergenInput;
}>;


export type UpdateAllergenMutation = { updateAllergen?: { __typename?: 'Allergen', id?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type CreateFoodCategoryMutationVariables = Exact<{
  input: CreateFoodCategoryInput;
}>;


export type CreateFoodCategoryMutation = { createFoodCategory?: { __typename?: 'FoodCategory', id?: string | null, name?: string | null, subtitle?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type DeleteFoodCategoryMutationVariables = Exact<{
  input: DeleteFoodCategoryInput;
}>;


export type DeleteFoodCategoryMutation = { deleteFoodCategory?: { __typename?: 'FoodCategory', id?: string | null } | null };

export type GetFoodCategoriesQueryVariables = Exact<{
  Limit?: InputMaybe<Scalars['Int']['input']>;
  NextToken?: InputMaybe<Scalars['String']['input']>;
  Filter?: InputMaybe<FilterFoodCategoryInput>;
}>;


export type GetFoodCategoriesQuery = { listFoodCategories?: { __typename?: 'PaginatedFoodCategories', items?: Array<{ __typename?: 'FoodCategory', id?: string | null, name?: string | null, subtitle?: string | null, is_active?: boolean | null, updated_at?: number | null } | null> | null } | null };

export type UpdateFoodCategoryMutationVariables = Exact<{
  input: UpdateFoodCategoryInput;
}>;


export type UpdateFoodCategoryMutation = { updateFoodCategory?: { __typename?: 'FoodCategory', id?: string | null, name?: string | null, subtitle?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type CreateFoodMenueMutationVariables = Exact<{
  input: CreateFoodMenueInput;
}>;


export type CreateFoodMenueMutation = { createFoodMenue?: { __typename?: 'FoodMenue', id?: string | null, title?: string | null, subtitle?: string | null, price?: string | null, is_active?: boolean | null, updated_at?: number | null, category?: { __typename?: 'SelectOption', value?: string | null, description?: string | null, label?: string | null } | null, foodtype?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, productinformation?: Array<{ __typename?: 'SelectOption', value?: string | null, label?: string | null } | null> | null } | null };

export type DeleteFoodMenueMutationVariables = Exact<{
  input: DeleteFoodMenueInput;
}>;


export type DeleteFoodMenueMutation = { deleteFoodMenue?: { __typename?: 'FoodMenue', id?: string | null } | null };

export type GetFoodMenuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFoodMenuesQuery = { listFoodMenues?: { __typename?: 'PaginatedFoodMenues', items?: Array<{ __typename?: 'FoodMenue', id?: string | null, title?: string | null, subtitle?: string | null, price?: string | null, sortnumber?: number | null, is_active?: boolean | null, updated_at?: number | null, category?: { __typename?: 'SelectOption', value?: string | null, description?: string | null, label?: string | null } | null, foodtype?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, productinformation?: Array<{ __typename?: 'SelectOption', value?: string | null, label?: string | null } | null> | null } | null> | null } | null };

export type UpdateFoodMenueMutationVariables = Exact<{
  input: UpdateFoodMenueInput;
}>;


export type UpdateFoodMenueMutation = { updateFoodMenue?: { __typename?: 'FoodMenue', id?: string | null, title?: string | null, subtitle?: string | null, price?: string | null, is_active?: boolean | null, updated_at?: number | null, category?: { __typename?: 'SelectOption', value?: string | null, description?: string | null, label?: string | null } | null, foodtype?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, productinformation?: Array<{ __typename?: 'SelectOption', value?: string | null, label?: string | null } | null> | null } | null };

export type CreateWebsiteLegalMutationVariables = Exact<{
  input: CreateWebsiteLegalInput;
}>;


export type CreateWebsiteLegalMutation = { createWebsiteLegal?: { __typename?: 'WebsiteLegal', id?: string | null, imprint?: string | null, disclaimer?: string | null } | null };

export type GetWebsiteLegalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsiteLegalQuery = { listWebsiteLegal?: { __typename?: 'PaginatedWebsiteLegal', items?: Array<{ __typename?: 'WebsiteLegal', id?: string | null, imprint?: string | null, disclaimer?: string | null } | null> | null } | null };

export type UpdateWebsiteLegalMutationVariables = Exact<{
  input: UpdateWebsiteLegalInput;
}>;


export type UpdateWebsiteLegalMutation = { updateWebsiteLegal?: { __typename?: 'WebsiteLegal', id?: string | null, imprint?: string | null, disclaimer?: string | null } | null };

export type CreateWebsiteNewsMutationVariables = Exact<{
  input: CreateWebsiteNewsInput;
}>;


export type CreateWebsiteNewsMutation = { createWebsiteNews?: { __typename?: 'WebsiteNews', id?: string | null, title?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type DeleteWebsiteNewsMutationVariables = Exact<{
  input: DeleteWebsiteNewsInput;
}>;


export type DeleteWebsiteNewsMutation = { deleteWebsiteNews?: { __typename?: 'WebsiteNews', id?: string | null } | null };

export type GetWebsiteNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsiteNewsQuery = { listWebsiteNews?: { __typename?: 'PaginatedWebsiteNews', items?: Array<{ __typename?: 'WebsiteNews', id?: string | null, title?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null> | null } | null };

export type UpdateWebsiteNewsMutationVariables = Exact<{
  input: UpdateWebsiteNewsInput;
}>;


export type UpdateWebsiteNewsMutation = { updateWebsiteNews?: { __typename?: 'WebsiteNews', id?: string | null, title?: string | null, text?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type CreateWebsitePartnerMutationVariables = Exact<{
  input: CreateWebsitePartnerInput;
}>;


export type CreateWebsitePartnerMutation = { createWebsitePartner?: { __typename?: 'WebsitePartner', id?: string | null, name?: string | null, url?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type DeleteWebsitePartnerMutationVariables = Exact<{
  input: DeleteWebsitePartnerInput;
}>;


export type DeleteWebsitePartnerMutation = { deleteWebsitePartner?: { __typename?: 'WebsitePartner', id?: string | null } | null };

export type GetWebsitePartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebsitePartnersQuery = { listWebsitePartners?: { __typename?: 'PaginatedWebsitePartners', items?: Array<{ __typename?: 'WebsitePartner', id?: string | null, name?: string | null, url?: string | null, is_active?: boolean | null, updated_at?: number | null } | null> | null } | null };

export type UpdateWebsitePartnerMutationVariables = Exact<{
  input: UpdateWebsitePartnerInput;
}>;


export type UpdateWebsitePartnerMutation = { updateWebsitePartner?: { __typename?: 'WebsitePartner', id?: string | null, name?: string | null, url?: string | null, is_active?: boolean | null, updated_at?: number | null } | null };

export type CreateWeeklyFoodMenueMutationVariables = Exact<{
  input: CreateFoodMenueInput;
}>;


export type CreateWeeklyFoodMenueMutation = { createWeeklyFoodMenue?: { __typename?: 'FoodMenue', id?: string | null, title?: string | null, subtitle?: string | null, price?: string | null, is_active?: boolean | null, displayday?: number | null, week?: number | null, updated_at?: number | null, foodtype?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, productinformation?: Array<{ __typename?: 'SelectOption', value?: string | null, label?: string | null } | null> | null } | null };

export type DeleteWeeklyFoodMenueMutationVariables = Exact<{
  input: DeleteFoodMenueInput;
}>;


export type DeleteWeeklyFoodMenueMutation = { deleteFoodMenue?: { __typename?: 'FoodMenue', id?: string | null } | null };

export type GetWeeklyFoodMenuesQueryVariables = Exact<{
  Limit?: InputMaybe<Scalars['Int']['input']>;
  NextToken?: InputMaybe<Scalars['String']['input']>;
  Filter?: InputMaybe<FilterFoodMenueInput>;
}>;


export type GetWeeklyFoodMenuesQuery = { listWeeklyFoodMenues?: { __typename?: 'PaginatedFoodMenues', items?: Array<{ __typename?: 'FoodMenue', id?: string | null, title?: string | null, subtitle?: string | null, price?: string | null, is_active?: boolean | null, displayday?: number | null, week?: number | null, updated_at?: number | null, foodtype?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, productinformation?: Array<{ __typename?: 'SelectOption', value?: string | null, label?: string | null } | null> | null } | null> | null } | null };

export type UpdateWeeklyFoodMenueMutationVariables = Exact<{
  input: UpdateFoodMenueInput;
}>;


export type UpdateWeeklyFoodMenueMutation = { updateFoodMenue?: { __typename?: 'FoodMenue', id?: string | null, title?: string | null, subtitle?: string | null, price?: string | null, is_active?: boolean | null, displayday?: number | null, week?: number | null, updated_at?: number | null, foodtype?: { __typename?: 'SelectOption', value?: string | null, label?: string | null } | null, productinformation?: Array<{ __typename?: 'SelectOption', value?: string | null, label?: string | null } | null> | null } | null };


export const CreateUserinformationDocument = gql`
    mutation CreateUserinformation($input: CreateUserinformationInput!) {
  createUserinformation(input: $input) {
    id
    name
    from
    to
    description
    notifyUserOnWebsite
    is_closed
    notifyStartDate
    updated_at
  }
}
    `;
export type CreateUserinformationMutationFn = Apollo.MutationFunction<CreateUserinformationMutation, CreateUserinformationMutationVariables>;

/**
 * __useCreateUserinformationMutation__
 *
 * To run a mutation, you first call `useCreateUserinformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserinformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserinformationMutation, { data, loading, error }] = useCreateUserinformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserinformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserinformationMutation, CreateUserinformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserinformationMutation, CreateUserinformationMutationVariables>(CreateUserinformationDocument, options);
      }
export type CreateUserinformationMutationHookResult = ReturnType<typeof useCreateUserinformationMutation>;
export type CreateUserinformationMutationResult = Apollo.MutationResult<CreateUserinformationMutation>;
export type CreateUserinformationMutationOptions = Apollo.BaseMutationOptions<CreateUserinformationMutation, CreateUserinformationMutationVariables>;
export const DeleteUserinformationDocument = gql`
    mutation DeleteUserinformation($input: DeleteUserinformationInput!) {
  deleteUserinformation(input: $input) {
    id
  }
}
    `;
export type DeleteUserinformationMutationFn = Apollo.MutationFunction<DeleteUserinformationMutation, DeleteUserinformationMutationVariables>;

/**
 * __useDeleteUserinformationMutation__
 *
 * To run a mutation, you first call `useDeleteUserinformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserinformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserinformationMutation, { data, loading, error }] = useDeleteUserinformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserinformationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserinformationMutation, DeleteUserinformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserinformationMutation, DeleteUserinformationMutationVariables>(DeleteUserinformationDocument, options);
      }
export type DeleteUserinformationMutationHookResult = ReturnType<typeof useDeleteUserinformationMutation>;
export type DeleteUserinformationMutationResult = Apollo.MutationResult<DeleteUserinformationMutation>;
export type DeleteUserinformationMutationOptions = Apollo.BaseMutationOptions<DeleteUserinformationMutation, DeleteUserinformationMutationVariables>;
export const GetUserinformationsDocument = gql`
    query GetUserinformations {
  listUserinformations {
    items {
      id
      name
      from
      to
      description
      notifyUserOnWebsite
      is_closed
      notifyStartDate
      updated_at
    }
  }
}
    `;

/**
 * __useGetUserinformationsQuery__
 *
 * To run a query within a React component, call `useGetUserinformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserinformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserinformationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserinformationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserinformationsQuery, GetUserinformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserinformationsQuery, GetUserinformationsQueryVariables>(GetUserinformationsDocument, options);
      }
export function useGetUserinformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserinformationsQuery, GetUserinformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserinformationsQuery, GetUserinformationsQueryVariables>(GetUserinformationsDocument, options);
        }
export function useGetUserinformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserinformationsQuery, GetUserinformationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserinformationsQuery, GetUserinformationsQueryVariables>(GetUserinformationsDocument, options);
        }
export type GetUserinformationsQueryHookResult = ReturnType<typeof useGetUserinformationsQuery>;
export type GetUserinformationsLazyQueryHookResult = ReturnType<typeof useGetUserinformationsLazyQuery>;
export type GetUserinformationsSuspenseQueryHookResult = ReturnType<typeof useGetUserinformationsSuspenseQuery>;
export type GetUserinformationsQueryResult = Apollo.QueryResult<GetUserinformationsQuery, GetUserinformationsQueryVariables>;
export const UpdateHolidayDocument = gql`
    mutation UpdateHoliday($input: UpdateUserinformationInput!) {
  updateUserinformation(input: $input) {
    id
    name
    from
    to
    description
    notifyUserOnWebsite
    is_closed
    notifyStartDate
    updated_at
  }
}
    `;
export type UpdateHolidayMutationFn = Apollo.MutationFunction<UpdateHolidayMutation, UpdateHolidayMutationVariables>;

/**
 * __useUpdateHolidayMutation__
 *
 * To run a mutation, you first call `useUpdateHolidayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHolidayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHolidayMutation, { data, loading, error }] = useUpdateHolidayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHolidayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHolidayMutation, UpdateHolidayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHolidayMutation, UpdateHolidayMutationVariables>(UpdateHolidayDocument, options);
      }
export type UpdateHolidayMutationHookResult = ReturnType<typeof useUpdateHolidayMutation>;
export type UpdateHolidayMutationResult = Apollo.MutationResult<UpdateHolidayMutation>;
export type UpdateHolidayMutationOptions = Apollo.BaseMutationOptions<UpdateHolidayMutation, UpdateHolidayMutationVariables>;
export const CreateWebsiteSettingsDocument = gql`
    mutation CreateWebsiteSettings($input: CreateWebsiteSettingsInput!) {
  createWebsiteSettings(input: $input) {
    title
    author
    description
    keywords {
      value
    }
    opendayfrom {
      value
      label
    }
    opendayto {
      value
      label
    }
    opentimefrom
    opentimeto
    breakfasttimefrom
    breakfasttimeto
    streetname
    postalcode
    location
    telephonenumber
    email
  }
}
    `;
export type CreateWebsiteSettingsMutationFn = Apollo.MutationFunction<CreateWebsiteSettingsMutation, CreateWebsiteSettingsMutationVariables>;

/**
 * __useCreateWebsiteSettingsMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteSettingsMutation, { data, loading, error }] = useCreateWebsiteSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebsiteSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteSettingsMutation, CreateWebsiteSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteSettingsMutation, CreateWebsiteSettingsMutationVariables>(CreateWebsiteSettingsDocument, options);
      }
export type CreateWebsiteSettingsMutationHookResult = ReturnType<typeof useCreateWebsiteSettingsMutation>;
export type CreateWebsiteSettingsMutationResult = Apollo.MutationResult<CreateWebsiteSettingsMutation>;
export type CreateWebsiteSettingsMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteSettingsMutation, CreateWebsiteSettingsMutationVariables>;
export const GetWebsiteSectionsDocument = gql`
    query GetWebsiteSections {
  listWebsiteSections {
    items {
      id
      key
      title
      subtitle
    }
  }
}
    `;

/**
 * __useGetWebsiteSectionsQuery__
 *
 * To run a query within a React component, call `useGetWebsiteSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsiteSectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>(GetWebsiteSectionsDocument, options);
      }
export function useGetWebsiteSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>(GetWebsiteSectionsDocument, options);
        }
export function useGetWebsiteSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>(GetWebsiteSectionsDocument, options);
        }
export type GetWebsiteSectionsQueryHookResult = ReturnType<typeof useGetWebsiteSectionsQuery>;
export type GetWebsiteSectionsLazyQueryHookResult = ReturnType<typeof useGetWebsiteSectionsLazyQuery>;
export type GetWebsiteSectionsSuspenseQueryHookResult = ReturnType<typeof useGetWebsiteSectionsSuspenseQuery>;
export type GetWebsiteSectionsQueryResult = Apollo.QueryResult<GetWebsiteSectionsQuery, GetWebsiteSectionsQueryVariables>;
export const GetWebsiteSettingsDocument = gql`
    query GetWebsiteSettings {
  listWebsiteSettings {
    items {
      id
      title
      author
      description
      keywords {
        value
      }
      opendayfrom {
        value
        label
      }
      opendayto {
        value
        label
      }
      opentimefrom
      opentimeto
      breakfasttimefrom
      breakfasttimeto
      streetname
      postalcode
      location
      telephonenumber
      email
    }
  }
}
    `;

/**
 * __useGetWebsiteSettingsQuery__
 *
 * To run a query within a React component, call `useGetWebsiteSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsiteSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>(GetWebsiteSettingsDocument, options);
      }
export function useGetWebsiteSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>(GetWebsiteSettingsDocument, options);
        }
export function useGetWebsiteSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>(GetWebsiteSettingsDocument, options);
        }
export type GetWebsiteSettingsQueryHookResult = ReturnType<typeof useGetWebsiteSettingsQuery>;
export type GetWebsiteSettingsLazyQueryHookResult = ReturnType<typeof useGetWebsiteSettingsLazyQuery>;
export type GetWebsiteSettingsSuspenseQueryHookResult = ReturnType<typeof useGetWebsiteSettingsSuspenseQuery>;
export type GetWebsiteSettingsQueryResult = Apollo.QueryResult<GetWebsiteSettingsQuery, GetWebsiteSettingsQueryVariables>;
export const UpdateSortnumbersDocument = gql`
    mutation UpdateSortnumbers($id1: String!, $sortnumber1: Int!, $id2: String!, $sortnumber2: Int!) {
  updateSortnumbers(
    id1: $id1
    sortnumber1: $sortnumber1
    id2: $id2
    sortnumber2: $sortnumber2
  )
}
    `;
export type UpdateSortnumbersMutationFn = Apollo.MutationFunction<UpdateSortnumbersMutation, UpdateSortnumbersMutationVariables>;

/**
 * __useUpdateSortnumbersMutation__
 *
 * To run a mutation, you first call `useUpdateSortnumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSortnumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSortnumbersMutation, { data, loading, error }] = useUpdateSortnumbersMutation({
 *   variables: {
 *      id1: // value for 'id1'
 *      sortnumber1: // value for 'sortnumber1'
 *      id2: // value for 'id2'
 *      sortnumber2: // value for 'sortnumber2'
 *   },
 * });
 */
export function useUpdateSortnumbersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSortnumbersMutation, UpdateSortnumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSortnumbersMutation, UpdateSortnumbersMutationVariables>(UpdateSortnumbersDocument, options);
      }
export type UpdateSortnumbersMutationHookResult = ReturnType<typeof useUpdateSortnumbersMutation>;
export type UpdateSortnumbersMutationResult = Apollo.MutationResult<UpdateSortnumbersMutation>;
export type UpdateSortnumbersMutationOptions = Apollo.BaseMutationOptions<UpdateSortnumbersMutation, UpdateSortnumbersMutationVariables>;
export const UpdateWebsiteSectionDocument = gql`
    mutation UpdateWebsiteSection($input: UpdateWebsiteSectionInput!) {
  updateWebsiteSection(input: $input) {
    id
    title
    subtitle
  }
}
    `;
export type UpdateWebsiteSectionMutationFn = Apollo.MutationFunction<UpdateWebsiteSectionMutation, UpdateWebsiteSectionMutationVariables>;

/**
 * __useUpdateWebsiteSectionMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteSectionMutation, { data, loading, error }] = useUpdateWebsiteSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsiteSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsiteSectionMutation, UpdateWebsiteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsiteSectionMutation, UpdateWebsiteSectionMutationVariables>(UpdateWebsiteSectionDocument, options);
      }
export type UpdateWebsiteSectionMutationHookResult = ReturnType<typeof useUpdateWebsiteSectionMutation>;
export type UpdateWebsiteSectionMutationResult = Apollo.MutationResult<UpdateWebsiteSectionMutation>;
export type UpdateWebsiteSectionMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteSectionMutation, UpdateWebsiteSectionMutationVariables>;
export const UpdateWebsiteSettingsDocument = gql`
    mutation UpdateWebsiteSettings($input: UpdateWebsiteSettingsInput!) {
  updateWebsiteSettings(input: $input) {
    id
    title
    author
    description
    keywords {
      value
    }
    opendayfrom {
      value
      label
    }
    opendayto {
      value
      label
    }
    opentimefrom
    opentimeto
    breakfasttimefrom
    breakfasttimeto
    streetname
    postalcode
    location
    telephonenumber
    email
  }
}
    `;
export type UpdateWebsiteSettingsMutationFn = Apollo.MutationFunction<UpdateWebsiteSettingsMutation, UpdateWebsiteSettingsMutationVariables>;

/**
 * __useUpdateWebsiteSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteSettingsMutation, { data, loading, error }] = useUpdateWebsiteSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsiteSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsiteSettingsMutation, UpdateWebsiteSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsiteSettingsMutation, UpdateWebsiteSettingsMutationVariables>(UpdateWebsiteSettingsDocument, options);
      }
export type UpdateWebsiteSettingsMutationHookResult = ReturnType<typeof useUpdateWebsiteSettingsMutation>;
export type UpdateWebsiteSettingsMutationResult = Apollo.MutationResult<UpdateWebsiteSettingsMutation>;
export type UpdateWebsiteSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteSettingsMutation, UpdateWebsiteSettingsMutationVariables>;
export const CreateWebsiteEventsDocument = gql`
    mutation CreateWebsiteEvents($input: CreateWebsiteEventsInput!) {
  createWebsiteEvents(input: $input) {
    id
    title
    location
    from
    to
    imageurl
    is_active
    updated_at
  }
}
    `;
export type CreateWebsiteEventsMutationFn = Apollo.MutationFunction<CreateWebsiteEventsMutation, CreateWebsiteEventsMutationVariables>;

/**
 * __useCreateWebsiteEventsMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteEventsMutation, { data, loading, error }] = useCreateWebsiteEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebsiteEventsMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteEventsMutation, CreateWebsiteEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteEventsMutation, CreateWebsiteEventsMutationVariables>(CreateWebsiteEventsDocument, options);
      }
export type CreateWebsiteEventsMutationHookResult = ReturnType<typeof useCreateWebsiteEventsMutation>;
export type CreateWebsiteEventsMutationResult = Apollo.MutationResult<CreateWebsiteEventsMutation>;
export type CreateWebsiteEventsMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteEventsMutation, CreateWebsiteEventsMutationVariables>;
export const DeleteWebsiteEventsDocument = gql`
    mutation DeleteWebsiteEvents($input: DeleteWebsiteEventsInput!) {
  deleteWebsiteEvents(input: $input) {
    id
    imageurl
  }
}
    `;
export type DeleteWebsiteEventsMutationFn = Apollo.MutationFunction<DeleteWebsiteEventsMutation, DeleteWebsiteEventsMutationVariables>;

/**
 * __useDeleteWebsiteEventsMutation__
 *
 * To run a mutation, you first call `useDeleteWebsiteEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebsiteEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebsiteEventsMutation, { data, loading, error }] = useDeleteWebsiteEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWebsiteEventsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebsiteEventsMutation, DeleteWebsiteEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebsiteEventsMutation, DeleteWebsiteEventsMutationVariables>(DeleteWebsiteEventsDocument, options);
      }
export type DeleteWebsiteEventsMutationHookResult = ReturnType<typeof useDeleteWebsiteEventsMutation>;
export type DeleteWebsiteEventsMutationResult = Apollo.MutationResult<DeleteWebsiteEventsMutation>;
export type DeleteWebsiteEventsMutationOptions = Apollo.BaseMutationOptions<DeleteWebsiteEventsMutation, DeleteWebsiteEventsMutationVariables>;
export const GetWebsiteEventsDocument = gql`
    query GetWebsiteEvents {
  listWebsiteEvents {
    items {
      id
      title
      location
      from
      to
      imageurl
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetWebsiteEventsQuery__
 *
 * To run a query within a React component, call `useGetWebsiteEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsiteEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>(GetWebsiteEventsDocument, options);
      }
export function useGetWebsiteEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>(GetWebsiteEventsDocument, options);
        }
export function useGetWebsiteEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>(GetWebsiteEventsDocument, options);
        }
export type GetWebsiteEventsQueryHookResult = ReturnType<typeof useGetWebsiteEventsQuery>;
export type GetWebsiteEventsLazyQueryHookResult = ReturnType<typeof useGetWebsiteEventsLazyQuery>;
export type GetWebsiteEventsSuspenseQueryHookResult = ReturnType<typeof useGetWebsiteEventsSuspenseQuery>;
export type GetWebsiteEventsQueryResult = Apollo.QueryResult<GetWebsiteEventsQuery, GetWebsiteEventsQueryVariables>;
export const UpdateWebsiteEventsDocument = gql`
    mutation UpdateWebsiteEvents($input: UpdateWebsiteEventsInput!) {
  updateWebsiteEvents(input: $input) {
    id
    title
    location
    from
    to
    imageurl
    is_active
    updated_at
  }
}
    `;
export type UpdateWebsiteEventsMutationFn = Apollo.MutationFunction<UpdateWebsiteEventsMutation, UpdateWebsiteEventsMutationVariables>;

/**
 * __useUpdateWebsiteEventsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteEventsMutation, { data, loading, error }] = useUpdateWebsiteEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsiteEventsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsiteEventsMutation, UpdateWebsiteEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsiteEventsMutation, UpdateWebsiteEventsMutationVariables>(UpdateWebsiteEventsDocument, options);
      }
export type UpdateWebsiteEventsMutationHookResult = ReturnType<typeof useUpdateWebsiteEventsMutation>;
export type UpdateWebsiteEventsMutationResult = Apollo.MutationResult<UpdateWebsiteEventsMutation>;
export type UpdateWebsiteEventsMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteEventsMutation, UpdateWebsiteEventsMutationVariables>;
export const CreateAdditiveDocument = gql`
    mutation CreateAdditive($input: CreateAdditiveInput!) {
  createAdditive(input: $input) {
    id
    text
    is_active
    updated_at
  }
}
    `;
export type CreateAdditiveMutationFn = Apollo.MutationFunction<CreateAdditiveMutation, CreateAdditiveMutationVariables>;

/**
 * __useCreateAdditiveMutation__
 *
 * To run a mutation, you first call `useCreateAdditiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditiveMutation, { data, loading, error }] = useCreateAdditiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdditiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditiveMutation, CreateAdditiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditiveMutation, CreateAdditiveMutationVariables>(CreateAdditiveDocument, options);
      }
export type CreateAdditiveMutationHookResult = ReturnType<typeof useCreateAdditiveMutation>;
export type CreateAdditiveMutationResult = Apollo.MutationResult<CreateAdditiveMutation>;
export type CreateAdditiveMutationOptions = Apollo.BaseMutationOptions<CreateAdditiveMutation, CreateAdditiveMutationVariables>;
export const DeleteAdditiveDocument = gql`
    mutation DeleteAdditive($input: DeleteAdditiveInput!) {
  deleteAdditive(input: $input) {
    id
  }
}
    `;
export type DeleteAdditiveMutationFn = Apollo.MutationFunction<DeleteAdditiveMutation, DeleteAdditiveMutationVariables>;

/**
 * __useDeleteAdditiveMutation__
 *
 * To run a mutation, you first call `useDeleteAdditiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdditiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdditiveMutation, { data, loading, error }] = useDeleteAdditiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAdditiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdditiveMutation, DeleteAdditiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdditiveMutation, DeleteAdditiveMutationVariables>(DeleteAdditiveDocument, options);
      }
export type DeleteAdditiveMutationHookResult = ReturnType<typeof useDeleteAdditiveMutation>;
export type DeleteAdditiveMutationResult = Apollo.MutationResult<DeleteAdditiveMutation>;
export type DeleteAdditiveMutationOptions = Apollo.BaseMutationOptions<DeleteAdditiveMutation, DeleteAdditiveMutationVariables>;
export const GetAdditivesDocument = gql`
    query GetAdditives($Limit: Int, $NextToken: String, $Filter: FilterAdditiveInput) {
  listAdditives(limit: $Limit, nextToken: $NextToken, filter: $Filter) {
    items {
      id
      text
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetAdditivesQuery__
 *
 * To run a query within a React component, call `useGetAdditivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditivesQuery({
 *   variables: {
 *      Limit: // value for 'Limit'
 *      NextToken: // value for 'NextToken'
 *      Filter: // value for 'Filter'
 *   },
 * });
 */
export function useGetAdditivesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdditivesQuery, GetAdditivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditivesQuery, GetAdditivesQueryVariables>(GetAdditivesDocument, options);
      }
export function useGetAdditivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditivesQuery, GetAdditivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditivesQuery, GetAdditivesQueryVariables>(GetAdditivesDocument, options);
        }
export function useGetAdditivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdditivesQuery, GetAdditivesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdditivesQuery, GetAdditivesQueryVariables>(GetAdditivesDocument, options);
        }
export type GetAdditivesQueryHookResult = ReturnType<typeof useGetAdditivesQuery>;
export type GetAdditivesLazyQueryHookResult = ReturnType<typeof useGetAdditivesLazyQuery>;
export type GetAdditivesSuspenseQueryHookResult = ReturnType<typeof useGetAdditivesSuspenseQuery>;
export type GetAdditivesQueryResult = Apollo.QueryResult<GetAdditivesQuery, GetAdditivesQueryVariables>;
export const UpdateAdditiveDocument = gql`
    mutation UpdateAdditive($input: UpdateAdditiveInput!) {
  updateAdditive(input: $input) {
    id
    text
    is_active
    updated_at
  }
}
    `;
export type UpdateAdditiveMutationFn = Apollo.MutationFunction<UpdateAdditiveMutation, UpdateAdditiveMutationVariables>;

/**
 * __useUpdateAdditiveMutation__
 *
 * To run a mutation, you first call `useUpdateAdditiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditiveMutation, { data, loading, error }] = useUpdateAdditiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdditiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditiveMutation, UpdateAdditiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditiveMutation, UpdateAdditiveMutationVariables>(UpdateAdditiveDocument, options);
      }
export type UpdateAdditiveMutationHookResult = ReturnType<typeof useUpdateAdditiveMutation>;
export type UpdateAdditiveMutationResult = Apollo.MutationResult<UpdateAdditiveMutation>;
export type UpdateAdditiveMutationOptions = Apollo.BaseMutationOptions<UpdateAdditiveMutation, UpdateAdditiveMutationVariables>;
export const CreateAllergenDocument = gql`
    mutation CreateAllergen($input: CreateAllergenInput!) {
  createAllergen(input: $input) {
    id
    text
    is_active
    updated_at
  }
}
    `;
export type CreateAllergenMutationFn = Apollo.MutationFunction<CreateAllergenMutation, CreateAllergenMutationVariables>;

/**
 * __useCreateAllergenMutation__
 *
 * To run a mutation, you first call `useCreateAllergenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllergenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllergenMutation, { data, loading, error }] = useCreateAllergenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllergenMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllergenMutation, CreateAllergenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllergenMutation, CreateAllergenMutationVariables>(CreateAllergenDocument, options);
      }
export type CreateAllergenMutationHookResult = ReturnType<typeof useCreateAllergenMutation>;
export type CreateAllergenMutationResult = Apollo.MutationResult<CreateAllergenMutation>;
export type CreateAllergenMutationOptions = Apollo.BaseMutationOptions<CreateAllergenMutation, CreateAllergenMutationVariables>;
export const DeleteAllergenDocument = gql`
    mutation DeleteAllergen($input: DeleteAllergenInput!) {
  deleteAllergen(input: $input) {
    id
  }
}
    `;
export type DeleteAllergenMutationFn = Apollo.MutationFunction<DeleteAllergenMutation, DeleteAllergenMutationVariables>;

/**
 * __useDeleteAllergenMutation__
 *
 * To run a mutation, you first call `useDeleteAllergenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllergenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllergenMutation, { data, loading, error }] = useDeleteAllergenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllergenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllergenMutation, DeleteAllergenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllergenMutation, DeleteAllergenMutationVariables>(DeleteAllergenDocument, options);
      }
export type DeleteAllergenMutationHookResult = ReturnType<typeof useDeleteAllergenMutation>;
export type DeleteAllergenMutationResult = Apollo.MutationResult<DeleteAllergenMutation>;
export type DeleteAllergenMutationOptions = Apollo.BaseMutationOptions<DeleteAllergenMutation, DeleteAllergenMutationVariables>;
export const GetAllergensDocument = gql`
    query GetAllergens($Limit: Int, $NextToken: String, $Filter: FilterAllergeneInput) {
  listAllergens(limit: $Limit, nextToken: $NextToken, filter: $Filter) {
    items {
      id
      text
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetAllergensQuery__
 *
 * To run a query within a React component, call `useGetAllergensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllergensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllergensQuery({
 *   variables: {
 *      Limit: // value for 'Limit'
 *      NextToken: // value for 'NextToken'
 *      Filter: // value for 'Filter'
 *   },
 * });
 */
export function useGetAllergensQuery(baseOptions?: Apollo.QueryHookOptions<GetAllergensQuery, GetAllergensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllergensQuery, GetAllergensQueryVariables>(GetAllergensDocument, options);
      }
export function useGetAllergensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllergensQuery, GetAllergensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllergensQuery, GetAllergensQueryVariables>(GetAllergensDocument, options);
        }
export function useGetAllergensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllergensQuery, GetAllergensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllergensQuery, GetAllergensQueryVariables>(GetAllergensDocument, options);
        }
export type GetAllergensQueryHookResult = ReturnType<typeof useGetAllergensQuery>;
export type GetAllergensLazyQueryHookResult = ReturnType<typeof useGetAllergensLazyQuery>;
export type GetAllergensSuspenseQueryHookResult = ReturnType<typeof useGetAllergensSuspenseQuery>;
export type GetAllergensQueryResult = Apollo.QueryResult<GetAllergensQuery, GetAllergensQueryVariables>;
export const UpdateAllergenDocument = gql`
    mutation UpdateAllergen($input: UpdateAllergenInput!) {
  updateAllergen(input: $input) {
    id
    text
    is_active
    updated_at
  }
}
    `;
export type UpdateAllergenMutationFn = Apollo.MutationFunction<UpdateAllergenMutation, UpdateAllergenMutationVariables>;

/**
 * __useUpdateAllergenMutation__
 *
 * To run a mutation, you first call `useUpdateAllergenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllergenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllergenMutation, { data, loading, error }] = useUpdateAllergenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllergenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllergenMutation, UpdateAllergenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllergenMutation, UpdateAllergenMutationVariables>(UpdateAllergenDocument, options);
      }
export type UpdateAllergenMutationHookResult = ReturnType<typeof useUpdateAllergenMutation>;
export type UpdateAllergenMutationResult = Apollo.MutationResult<UpdateAllergenMutation>;
export type UpdateAllergenMutationOptions = Apollo.BaseMutationOptions<UpdateAllergenMutation, UpdateAllergenMutationVariables>;
export const CreateFoodCategoryDocument = gql`
    mutation CreateFoodCategory($input: CreateFoodCategoryInput!) {
  createFoodCategory(input: $input) {
    id
    name
    subtitle
    is_active
    updated_at
  }
}
    `;
export type CreateFoodCategoryMutationFn = Apollo.MutationFunction<CreateFoodCategoryMutation, CreateFoodCategoryMutationVariables>;

/**
 * __useCreateFoodCategoryMutation__
 *
 * To run a mutation, you first call `useCreateFoodCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFoodCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFoodCategoryMutation, { data, loading, error }] = useCreateFoodCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFoodCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateFoodCategoryMutation, CreateFoodCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFoodCategoryMutation, CreateFoodCategoryMutationVariables>(CreateFoodCategoryDocument, options);
      }
export type CreateFoodCategoryMutationHookResult = ReturnType<typeof useCreateFoodCategoryMutation>;
export type CreateFoodCategoryMutationResult = Apollo.MutationResult<CreateFoodCategoryMutation>;
export type CreateFoodCategoryMutationOptions = Apollo.BaseMutationOptions<CreateFoodCategoryMutation, CreateFoodCategoryMutationVariables>;
export const DeleteFoodCategoryDocument = gql`
    mutation DeleteFoodCategory($input: DeleteFoodCategoryInput!) {
  deleteFoodCategory(input: $input) {
    id
  }
}
    `;
export type DeleteFoodCategoryMutationFn = Apollo.MutationFunction<DeleteFoodCategoryMutation, DeleteFoodCategoryMutationVariables>;

/**
 * __useDeleteFoodCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteFoodCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFoodCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFoodCategoryMutation, { data, loading, error }] = useDeleteFoodCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFoodCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFoodCategoryMutation, DeleteFoodCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFoodCategoryMutation, DeleteFoodCategoryMutationVariables>(DeleteFoodCategoryDocument, options);
      }
export type DeleteFoodCategoryMutationHookResult = ReturnType<typeof useDeleteFoodCategoryMutation>;
export type DeleteFoodCategoryMutationResult = Apollo.MutationResult<DeleteFoodCategoryMutation>;
export type DeleteFoodCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteFoodCategoryMutation, DeleteFoodCategoryMutationVariables>;
export const GetFoodCategoriesDocument = gql`
    query GetFoodCategories($Limit: Int, $NextToken: String, $Filter: FilterFoodCategoryInput) {
  listFoodCategories(limit: $Limit, nextToken: $NextToken, filter: $Filter) {
    items {
      id
      name
      subtitle
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetFoodCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFoodCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodCategoriesQuery({
 *   variables: {
 *      Limit: // value for 'Limit'
 *      NextToken: // value for 'NextToken'
 *      Filter: // value for 'Filter'
 *   },
 * });
 */
export function useGetFoodCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>(GetFoodCategoriesDocument, options);
      }
export function useGetFoodCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>(GetFoodCategoriesDocument, options);
        }
export function useGetFoodCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>(GetFoodCategoriesDocument, options);
        }
export type GetFoodCategoriesQueryHookResult = ReturnType<typeof useGetFoodCategoriesQuery>;
export type GetFoodCategoriesLazyQueryHookResult = ReturnType<typeof useGetFoodCategoriesLazyQuery>;
export type GetFoodCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetFoodCategoriesSuspenseQuery>;
export type GetFoodCategoriesQueryResult = Apollo.QueryResult<GetFoodCategoriesQuery, GetFoodCategoriesQueryVariables>;
export const UpdateFoodCategoryDocument = gql`
    mutation UpdateFoodCategory($input: UpdateFoodCategoryInput!) {
  updateFoodCategory(input: $input) {
    id
    name
    subtitle
    is_active
    updated_at
  }
}
    `;
export type UpdateFoodCategoryMutationFn = Apollo.MutationFunction<UpdateFoodCategoryMutation, UpdateFoodCategoryMutationVariables>;

/**
 * __useUpdateFoodCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateFoodCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFoodCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFoodCategoryMutation, { data, loading, error }] = useUpdateFoodCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFoodCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFoodCategoryMutation, UpdateFoodCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFoodCategoryMutation, UpdateFoodCategoryMutationVariables>(UpdateFoodCategoryDocument, options);
      }
export type UpdateFoodCategoryMutationHookResult = ReturnType<typeof useUpdateFoodCategoryMutation>;
export type UpdateFoodCategoryMutationResult = Apollo.MutationResult<UpdateFoodCategoryMutation>;
export type UpdateFoodCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateFoodCategoryMutation, UpdateFoodCategoryMutationVariables>;
export const CreateFoodMenueDocument = gql`
    mutation CreateFoodMenue($input: CreateFoodMenueInput!) {
  createFoodMenue(input: $input) {
    id
    title
    subtitle
    price
    category {
      value
      description
      label
    }
    foodtype {
      value
      label
    }
    productinformation {
      value
      label
    }
    is_active
    updated_at
  }
}
    `;
export type CreateFoodMenueMutationFn = Apollo.MutationFunction<CreateFoodMenueMutation, CreateFoodMenueMutationVariables>;

/**
 * __useCreateFoodMenueMutation__
 *
 * To run a mutation, you first call `useCreateFoodMenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFoodMenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFoodMenueMutation, { data, loading, error }] = useCreateFoodMenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFoodMenueMutation(baseOptions?: Apollo.MutationHookOptions<CreateFoodMenueMutation, CreateFoodMenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFoodMenueMutation, CreateFoodMenueMutationVariables>(CreateFoodMenueDocument, options);
      }
export type CreateFoodMenueMutationHookResult = ReturnType<typeof useCreateFoodMenueMutation>;
export type CreateFoodMenueMutationResult = Apollo.MutationResult<CreateFoodMenueMutation>;
export type CreateFoodMenueMutationOptions = Apollo.BaseMutationOptions<CreateFoodMenueMutation, CreateFoodMenueMutationVariables>;
export const DeleteFoodMenueDocument = gql`
    mutation DeleteFoodMenue($input: DeleteFoodMenueInput!) {
  deleteFoodMenue(input: $input) {
    id
  }
}
    `;
export type DeleteFoodMenueMutationFn = Apollo.MutationFunction<DeleteFoodMenueMutation, DeleteFoodMenueMutationVariables>;

/**
 * __useDeleteFoodMenueMutation__
 *
 * To run a mutation, you first call `useDeleteFoodMenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFoodMenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFoodMenueMutation, { data, loading, error }] = useDeleteFoodMenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFoodMenueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFoodMenueMutation, DeleteFoodMenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFoodMenueMutation, DeleteFoodMenueMutationVariables>(DeleteFoodMenueDocument, options);
      }
export type DeleteFoodMenueMutationHookResult = ReturnType<typeof useDeleteFoodMenueMutation>;
export type DeleteFoodMenueMutationResult = Apollo.MutationResult<DeleteFoodMenueMutation>;
export type DeleteFoodMenueMutationOptions = Apollo.BaseMutationOptions<DeleteFoodMenueMutation, DeleteFoodMenueMutationVariables>;
export const GetFoodMenuesDocument = gql`
    query GetFoodMenues {
  listFoodMenues {
    items {
      id
      title
      subtitle
      price
      category {
        value
        description
        label
      }
      foodtype {
        value
        label
      }
      productinformation {
        value
        label
      }
      sortnumber
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetFoodMenuesQuery__
 *
 * To run a query within a React component, call `useGetFoodMenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodMenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodMenuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFoodMenuesQuery(baseOptions?: Apollo.QueryHookOptions<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>(GetFoodMenuesDocument, options);
      }
export function useGetFoodMenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>(GetFoodMenuesDocument, options);
        }
export function useGetFoodMenuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>(GetFoodMenuesDocument, options);
        }
export type GetFoodMenuesQueryHookResult = ReturnType<typeof useGetFoodMenuesQuery>;
export type GetFoodMenuesLazyQueryHookResult = ReturnType<typeof useGetFoodMenuesLazyQuery>;
export type GetFoodMenuesSuspenseQueryHookResult = ReturnType<typeof useGetFoodMenuesSuspenseQuery>;
export type GetFoodMenuesQueryResult = Apollo.QueryResult<GetFoodMenuesQuery, GetFoodMenuesQueryVariables>;
export const UpdateFoodMenueDocument = gql`
    mutation UpdateFoodMenue($input: UpdateFoodMenueInput!) {
  updateFoodMenue(input: $input) {
    id
    title
    subtitle
    price
    category {
      value
      description
      label
    }
    foodtype {
      value
      label
    }
    productinformation {
      value
      label
    }
    is_active
    updated_at
  }
}
    `;
export type UpdateFoodMenueMutationFn = Apollo.MutationFunction<UpdateFoodMenueMutation, UpdateFoodMenueMutationVariables>;

/**
 * __useUpdateFoodMenueMutation__
 *
 * To run a mutation, you first call `useUpdateFoodMenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFoodMenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFoodMenueMutation, { data, loading, error }] = useUpdateFoodMenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFoodMenueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFoodMenueMutation, UpdateFoodMenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFoodMenueMutation, UpdateFoodMenueMutationVariables>(UpdateFoodMenueDocument, options);
      }
export type UpdateFoodMenueMutationHookResult = ReturnType<typeof useUpdateFoodMenueMutation>;
export type UpdateFoodMenueMutationResult = Apollo.MutationResult<UpdateFoodMenueMutation>;
export type UpdateFoodMenueMutationOptions = Apollo.BaseMutationOptions<UpdateFoodMenueMutation, UpdateFoodMenueMutationVariables>;
export const CreateWebsiteLegalDocument = gql`
    mutation CreateWebsiteLegal($input: CreateWebsiteLegalInput!) {
  createWebsiteLegal(input: $input) {
    id
    imprint
    disclaimer
  }
}
    `;
export type CreateWebsiteLegalMutationFn = Apollo.MutationFunction<CreateWebsiteLegalMutation, CreateWebsiteLegalMutationVariables>;

/**
 * __useCreateWebsiteLegalMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteLegalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteLegalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteLegalMutation, { data, loading, error }] = useCreateWebsiteLegalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebsiteLegalMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteLegalMutation, CreateWebsiteLegalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteLegalMutation, CreateWebsiteLegalMutationVariables>(CreateWebsiteLegalDocument, options);
      }
export type CreateWebsiteLegalMutationHookResult = ReturnType<typeof useCreateWebsiteLegalMutation>;
export type CreateWebsiteLegalMutationResult = Apollo.MutationResult<CreateWebsiteLegalMutation>;
export type CreateWebsiteLegalMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteLegalMutation, CreateWebsiteLegalMutationVariables>;
export const GetWebsiteLegalDocument = gql`
    query GetWebsiteLegal {
  listWebsiteLegal {
    items {
      id
      imprint
      disclaimer
    }
  }
}
    `;

/**
 * __useGetWebsiteLegalQuery__
 *
 * To run a query within a React component, call `useGetWebsiteLegalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteLegalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteLegalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsiteLegalQuery(baseOptions?: Apollo.QueryHookOptions<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>(GetWebsiteLegalDocument, options);
      }
export function useGetWebsiteLegalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>(GetWebsiteLegalDocument, options);
        }
export function useGetWebsiteLegalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>(GetWebsiteLegalDocument, options);
        }
export type GetWebsiteLegalQueryHookResult = ReturnType<typeof useGetWebsiteLegalQuery>;
export type GetWebsiteLegalLazyQueryHookResult = ReturnType<typeof useGetWebsiteLegalLazyQuery>;
export type GetWebsiteLegalSuspenseQueryHookResult = ReturnType<typeof useGetWebsiteLegalSuspenseQuery>;
export type GetWebsiteLegalQueryResult = Apollo.QueryResult<GetWebsiteLegalQuery, GetWebsiteLegalQueryVariables>;
export const UpdateWebsiteLegalDocument = gql`
    mutation UpdateWebsiteLegal($input: UpdateWebsiteLegalInput!) {
  updateWebsiteLegal(input: $input) {
    id
    imprint
    disclaimer
  }
}
    `;
export type UpdateWebsiteLegalMutationFn = Apollo.MutationFunction<UpdateWebsiteLegalMutation, UpdateWebsiteLegalMutationVariables>;

/**
 * __useUpdateWebsiteLegalMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteLegalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteLegalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteLegalMutation, { data, loading, error }] = useUpdateWebsiteLegalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsiteLegalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsiteLegalMutation, UpdateWebsiteLegalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsiteLegalMutation, UpdateWebsiteLegalMutationVariables>(UpdateWebsiteLegalDocument, options);
      }
export type UpdateWebsiteLegalMutationHookResult = ReturnType<typeof useUpdateWebsiteLegalMutation>;
export type UpdateWebsiteLegalMutationResult = Apollo.MutationResult<UpdateWebsiteLegalMutation>;
export type UpdateWebsiteLegalMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteLegalMutation, UpdateWebsiteLegalMutationVariables>;
export const CreateWebsiteNewsDocument = gql`
    mutation CreateWebsiteNews($input: CreateWebsiteNewsInput!) {
  createWebsiteNews(input: $input) {
    id
    title
    text
    is_active
    updated_at
  }
}
    `;
export type CreateWebsiteNewsMutationFn = Apollo.MutationFunction<CreateWebsiteNewsMutation, CreateWebsiteNewsMutationVariables>;

/**
 * __useCreateWebsiteNewsMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteNewsMutation, { data, loading, error }] = useCreateWebsiteNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebsiteNewsMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteNewsMutation, CreateWebsiteNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteNewsMutation, CreateWebsiteNewsMutationVariables>(CreateWebsiteNewsDocument, options);
      }
export type CreateWebsiteNewsMutationHookResult = ReturnType<typeof useCreateWebsiteNewsMutation>;
export type CreateWebsiteNewsMutationResult = Apollo.MutationResult<CreateWebsiteNewsMutation>;
export type CreateWebsiteNewsMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteNewsMutation, CreateWebsiteNewsMutationVariables>;
export const DeleteWebsiteNewsDocument = gql`
    mutation DeleteWebsiteNews($input: DeleteWebsiteNewsInput!) {
  deleteWebsiteNews(input: $input) {
    id
  }
}
    `;
export type DeleteWebsiteNewsMutationFn = Apollo.MutationFunction<DeleteWebsiteNewsMutation, DeleteWebsiteNewsMutationVariables>;

/**
 * __useDeleteWebsiteNewsMutation__
 *
 * To run a mutation, you first call `useDeleteWebsiteNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebsiteNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebsiteNewsMutation, { data, loading, error }] = useDeleteWebsiteNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWebsiteNewsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebsiteNewsMutation, DeleteWebsiteNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebsiteNewsMutation, DeleteWebsiteNewsMutationVariables>(DeleteWebsiteNewsDocument, options);
      }
export type DeleteWebsiteNewsMutationHookResult = ReturnType<typeof useDeleteWebsiteNewsMutation>;
export type DeleteWebsiteNewsMutationResult = Apollo.MutationResult<DeleteWebsiteNewsMutation>;
export type DeleteWebsiteNewsMutationOptions = Apollo.BaseMutationOptions<DeleteWebsiteNewsMutation, DeleteWebsiteNewsMutationVariables>;
export const GetWebsiteNewsDocument = gql`
    query GetWebsiteNews {
  listWebsiteNews {
    items {
      id
      title
      text
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetWebsiteNewsQuery__
 *
 * To run a query within a React component, call `useGetWebsiteNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsiteNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>(GetWebsiteNewsDocument, options);
      }
export function useGetWebsiteNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>(GetWebsiteNewsDocument, options);
        }
export function useGetWebsiteNewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>(GetWebsiteNewsDocument, options);
        }
export type GetWebsiteNewsQueryHookResult = ReturnType<typeof useGetWebsiteNewsQuery>;
export type GetWebsiteNewsLazyQueryHookResult = ReturnType<typeof useGetWebsiteNewsLazyQuery>;
export type GetWebsiteNewsSuspenseQueryHookResult = ReturnType<typeof useGetWebsiteNewsSuspenseQuery>;
export type GetWebsiteNewsQueryResult = Apollo.QueryResult<GetWebsiteNewsQuery, GetWebsiteNewsQueryVariables>;
export const UpdateWebsiteNewsDocument = gql`
    mutation UpdateWebsiteNews($input: UpdateWebsiteNewsInput!) {
  updateWebsiteNews(input: $input) {
    id
    title
    text
    is_active
    updated_at
  }
}
    `;
export type UpdateWebsiteNewsMutationFn = Apollo.MutationFunction<UpdateWebsiteNewsMutation, UpdateWebsiteNewsMutationVariables>;

/**
 * __useUpdateWebsiteNewsMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteNewsMutation, { data, loading, error }] = useUpdateWebsiteNewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsiteNewsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsiteNewsMutation, UpdateWebsiteNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsiteNewsMutation, UpdateWebsiteNewsMutationVariables>(UpdateWebsiteNewsDocument, options);
      }
export type UpdateWebsiteNewsMutationHookResult = ReturnType<typeof useUpdateWebsiteNewsMutation>;
export type UpdateWebsiteNewsMutationResult = Apollo.MutationResult<UpdateWebsiteNewsMutation>;
export type UpdateWebsiteNewsMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteNewsMutation, UpdateWebsiteNewsMutationVariables>;
export const CreateWebsitePartnerDocument = gql`
    mutation CreateWebsitePartner($input: CreateWebsitePartnerInput!) {
  createWebsitePartner(input: $input) {
    id
    name
    url
    is_active
    updated_at
  }
}
    `;
export type CreateWebsitePartnerMutationFn = Apollo.MutationFunction<CreateWebsitePartnerMutation, CreateWebsitePartnerMutationVariables>;

/**
 * __useCreateWebsitePartnerMutation__
 *
 * To run a mutation, you first call `useCreateWebsitePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsitePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsitePartnerMutation, { data, loading, error }] = useCreateWebsitePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebsitePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsitePartnerMutation, CreateWebsitePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsitePartnerMutation, CreateWebsitePartnerMutationVariables>(CreateWebsitePartnerDocument, options);
      }
export type CreateWebsitePartnerMutationHookResult = ReturnType<typeof useCreateWebsitePartnerMutation>;
export type CreateWebsitePartnerMutationResult = Apollo.MutationResult<CreateWebsitePartnerMutation>;
export type CreateWebsitePartnerMutationOptions = Apollo.BaseMutationOptions<CreateWebsitePartnerMutation, CreateWebsitePartnerMutationVariables>;
export const DeleteWebsitePartnerDocument = gql`
    mutation DeleteWebsitePartner($input: DeleteWebsitePartnerInput!) {
  deleteWebsitePartner(input: $input) {
    id
  }
}
    `;
export type DeleteWebsitePartnerMutationFn = Apollo.MutationFunction<DeleteWebsitePartnerMutation, DeleteWebsitePartnerMutationVariables>;

/**
 * __useDeleteWebsitePartnerMutation__
 *
 * To run a mutation, you first call `useDeleteWebsitePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebsitePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebsitePartnerMutation, { data, loading, error }] = useDeleteWebsitePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWebsitePartnerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebsitePartnerMutation, DeleteWebsitePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebsitePartnerMutation, DeleteWebsitePartnerMutationVariables>(DeleteWebsitePartnerDocument, options);
      }
export type DeleteWebsitePartnerMutationHookResult = ReturnType<typeof useDeleteWebsitePartnerMutation>;
export type DeleteWebsitePartnerMutationResult = Apollo.MutationResult<DeleteWebsitePartnerMutation>;
export type DeleteWebsitePartnerMutationOptions = Apollo.BaseMutationOptions<DeleteWebsitePartnerMutation, DeleteWebsitePartnerMutationVariables>;
export const GetWebsitePartnersDocument = gql`
    query GetWebsitePartners {
  listWebsitePartners {
    items {
      id
      name
      url
      is_active
      updated_at
    }
  }
}
    `;

/**
 * __useGetWebsitePartnersQuery__
 *
 * To run a query within a React component, call `useGetWebsitePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsitePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsitePartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebsitePartnersQuery(baseOptions?: Apollo.QueryHookOptions<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>(GetWebsitePartnersDocument, options);
      }
export function useGetWebsitePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>(GetWebsitePartnersDocument, options);
        }
export function useGetWebsitePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>(GetWebsitePartnersDocument, options);
        }
export type GetWebsitePartnersQueryHookResult = ReturnType<typeof useGetWebsitePartnersQuery>;
export type GetWebsitePartnersLazyQueryHookResult = ReturnType<typeof useGetWebsitePartnersLazyQuery>;
export type GetWebsitePartnersSuspenseQueryHookResult = ReturnType<typeof useGetWebsitePartnersSuspenseQuery>;
export type GetWebsitePartnersQueryResult = Apollo.QueryResult<GetWebsitePartnersQuery, GetWebsitePartnersQueryVariables>;
export const UpdateWebsitePartnerDocument = gql`
    mutation UpdateWebsitePartner($input: UpdateWebsitePartnerInput!) {
  updateWebsitePartner(input: $input) {
    id
    name
    url
    is_active
    updated_at
  }
}
    `;
export type UpdateWebsitePartnerMutationFn = Apollo.MutationFunction<UpdateWebsitePartnerMutation, UpdateWebsitePartnerMutationVariables>;

/**
 * __useUpdateWebsitePartnerMutation__
 *
 * To run a mutation, you first call `useUpdateWebsitePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsitePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsitePartnerMutation, { data, loading, error }] = useUpdateWebsitePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsitePartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebsitePartnerMutation, UpdateWebsitePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebsitePartnerMutation, UpdateWebsitePartnerMutationVariables>(UpdateWebsitePartnerDocument, options);
      }
export type UpdateWebsitePartnerMutationHookResult = ReturnType<typeof useUpdateWebsitePartnerMutation>;
export type UpdateWebsitePartnerMutationResult = Apollo.MutationResult<UpdateWebsitePartnerMutation>;
export type UpdateWebsitePartnerMutationOptions = Apollo.BaseMutationOptions<UpdateWebsitePartnerMutation, UpdateWebsitePartnerMutationVariables>;
export const CreateWeeklyFoodMenueDocument = gql`
    mutation CreateWeeklyFoodMenue($input: CreateFoodMenueInput!) {
  createWeeklyFoodMenue(input: $input) {
    id
    title
    subtitle
    price
    foodtype {
      value
      label
    }
    productinformation {
      value
      label
    }
    is_active
    displayday
    week
    updated_at
  }
}
    `;
export type CreateWeeklyFoodMenueMutationFn = Apollo.MutationFunction<CreateWeeklyFoodMenueMutation, CreateWeeklyFoodMenueMutationVariables>;

/**
 * __useCreateWeeklyFoodMenueMutation__
 *
 * To run a mutation, you first call `useCreateWeeklyFoodMenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWeeklyFoodMenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWeeklyFoodMenueMutation, { data, loading, error }] = useCreateWeeklyFoodMenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWeeklyFoodMenueMutation(baseOptions?: Apollo.MutationHookOptions<CreateWeeklyFoodMenueMutation, CreateWeeklyFoodMenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWeeklyFoodMenueMutation, CreateWeeklyFoodMenueMutationVariables>(CreateWeeklyFoodMenueDocument, options);
      }
export type CreateWeeklyFoodMenueMutationHookResult = ReturnType<typeof useCreateWeeklyFoodMenueMutation>;
export type CreateWeeklyFoodMenueMutationResult = Apollo.MutationResult<CreateWeeklyFoodMenueMutation>;
export type CreateWeeklyFoodMenueMutationOptions = Apollo.BaseMutationOptions<CreateWeeklyFoodMenueMutation, CreateWeeklyFoodMenueMutationVariables>;
export const DeleteWeeklyFoodMenueDocument = gql`
    mutation DeleteWeeklyFoodMenue($input: DeleteFoodMenueInput!) {
  deleteFoodMenue(input: $input) {
    id
  }
}
    `;
export type DeleteWeeklyFoodMenueMutationFn = Apollo.MutationFunction<DeleteWeeklyFoodMenueMutation, DeleteWeeklyFoodMenueMutationVariables>;

/**
 * __useDeleteWeeklyFoodMenueMutation__
 *
 * To run a mutation, you first call `useDeleteWeeklyFoodMenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWeeklyFoodMenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWeeklyFoodMenueMutation, { data, loading, error }] = useDeleteWeeklyFoodMenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWeeklyFoodMenueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWeeklyFoodMenueMutation, DeleteWeeklyFoodMenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWeeklyFoodMenueMutation, DeleteWeeklyFoodMenueMutationVariables>(DeleteWeeklyFoodMenueDocument, options);
      }
export type DeleteWeeklyFoodMenueMutationHookResult = ReturnType<typeof useDeleteWeeklyFoodMenueMutation>;
export type DeleteWeeklyFoodMenueMutationResult = Apollo.MutationResult<DeleteWeeklyFoodMenueMutation>;
export type DeleteWeeklyFoodMenueMutationOptions = Apollo.BaseMutationOptions<DeleteWeeklyFoodMenueMutation, DeleteWeeklyFoodMenueMutationVariables>;
export const GetWeeklyFoodMenuesDocument = gql`
    query GetWeeklyFoodMenues($Limit: Int, $NextToken: String, $Filter: FilterFoodMenueInput) {
  listWeeklyFoodMenues(limit: $Limit, nextToken: $NextToken, filter: $Filter) {
    items {
      id
      title
      subtitle
      price
      foodtype {
        value
        label
      }
      productinformation {
        value
        label
      }
      is_active
      displayday
      week
      updated_at
    }
  }
}
    `;

/**
 * __useGetWeeklyFoodMenuesQuery__
 *
 * To run a query within a React component, call `useGetWeeklyFoodMenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyFoodMenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyFoodMenuesQuery({
 *   variables: {
 *      Limit: // value for 'Limit'
 *      NextToken: // value for 'NextToken'
 *      Filter: // value for 'Filter'
 *   },
 * });
 */
export function useGetWeeklyFoodMenuesQuery(baseOptions?: Apollo.QueryHookOptions<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>(GetWeeklyFoodMenuesDocument, options);
      }
export function useGetWeeklyFoodMenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>(GetWeeklyFoodMenuesDocument, options);
        }
export function useGetWeeklyFoodMenuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>(GetWeeklyFoodMenuesDocument, options);
        }
export type GetWeeklyFoodMenuesQueryHookResult = ReturnType<typeof useGetWeeklyFoodMenuesQuery>;
export type GetWeeklyFoodMenuesLazyQueryHookResult = ReturnType<typeof useGetWeeklyFoodMenuesLazyQuery>;
export type GetWeeklyFoodMenuesSuspenseQueryHookResult = ReturnType<typeof useGetWeeklyFoodMenuesSuspenseQuery>;
export type GetWeeklyFoodMenuesQueryResult = Apollo.QueryResult<GetWeeklyFoodMenuesQuery, GetWeeklyFoodMenuesQueryVariables>;
export const UpdateWeeklyFoodMenueDocument = gql`
    mutation UpdateWeeklyFoodMenue($input: UpdateFoodMenueInput!) {
  updateFoodMenue(input: $input) {
    id
    title
    subtitle
    price
    foodtype {
      value
      label
    }
    productinformation {
      value
      label
    }
    is_active
    displayday
    week
    updated_at
  }
}
    `;
export type UpdateWeeklyFoodMenueMutationFn = Apollo.MutationFunction<UpdateWeeklyFoodMenueMutation, UpdateWeeklyFoodMenueMutationVariables>;

/**
 * __useUpdateWeeklyFoodMenueMutation__
 *
 * To run a mutation, you first call `useUpdateWeeklyFoodMenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeeklyFoodMenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeeklyFoodMenueMutation, { data, loading, error }] = useUpdateWeeklyFoodMenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWeeklyFoodMenueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWeeklyFoodMenueMutation, UpdateWeeklyFoodMenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWeeklyFoodMenueMutation, UpdateWeeklyFoodMenueMutationVariables>(UpdateWeeklyFoodMenueDocument, options);
      }
export type UpdateWeeklyFoodMenueMutationHookResult = ReturnType<typeof useUpdateWeeklyFoodMenueMutation>;
export type UpdateWeeklyFoodMenueMutationResult = Apollo.MutationResult<UpdateWeeklyFoodMenueMutation>;
export type UpdateWeeklyFoodMenueMutationOptions = Apollo.BaseMutationOptions<UpdateWeeklyFoodMenueMutation, UpdateWeeklyFoodMenueMutationVariables>;